import { lazyWithPreload } from 'react-lazy-with-preload';

const PostListPage = lazyWithPreload(() => import('./pages/progress-line-post-list/Page'));
const SiteRFIAddPage = lazyWithPreload(() => import('./pages/site-rfi-add/Page'));
const SiteRFIDetailPage = lazyWithPreload(() => import('./pages/site-rfi-detail/Page'));
const SiteObservationAddPage = lazyWithPreload(() => import('./pages/site-observation-add/Page'));
const SiteObservationDetailPage = lazyWithPreload(() => import('./pages/site-observation-detail/Page'));
const SiteUploadAddPage = lazyWithPreload(() => import('./pages/site-upload-add/Page'));
const SiteUploadDetailPage = lazyWithPreload(() => import('./pages/site-upload-detail/Page'));

const Routes = [
    {
        path: 'site-note',
        element: <PostListPage />,
    },
    {
        path: 'site-note/:projectId/rfis/new',
        element: <SiteRFIAddPage />,
    },
    {
        path: 'site-note/:projectId/rfis/:noteId',
        element: <SiteRFIDetailPage />,
    },
    {
        path: 'site-note/:projectId/observations/new',
        element: <SiteObservationAddPage />,
    },
    {
        path: 'site-note/:projectId/observations/:noteId',
        element: <SiteObservationDetailPage />,
    },
    {
        path: 'site-note/:projectId/uploads/new',
        element: <SiteUploadAddPage />,
    },
    {
        path: 'site-note/:projectId/uploads/:noteId',
        element: <SiteUploadDetailPage />,
    },
];

export default Routes;
